/*
    Values in .env files are returned as strings.

    //In your .env file:
    myValue=false

    //WRONG:
    if(process.env.myValue) {
        //this code will execute since "false" evaluates to true in this case
    }

    //RIGHT:
    if(EnvUtils.isTrue(process.env.myValue)) {
        //will only execute if .env file contains "myValue=true"
    }


*/

export class EnvUtils {
  /**
   * Returns true if an env value is explicitly true.
   * @param value
   * @returns {boolean}
   */
  static isTrue(value) {
    if (value === 'true' || value === true) {
      return true;
    }

    return false;
  }

  /**
   * Returns true if an env value is NOT explicitly true.
   * @param value
   * @returns {boolean}
   */
  static isFalse(value) {
    return !this.isTrue(value);
  }
}
